//#region components/checkbox/checkbox_constants.js
var e = {
	critical: "d-checkbox--critical",
	warning: "d-checkbox--warning",
	positive: "d-checkbox--positive"
}, t = { CHECKBOX_INPUT_VALIDATION_CLASSES: e };
//#endregion
export { e as CHECKBOX_INPUT_VALIDATION_CLASSES, t as default };

//# sourceMappingURL=checkbox-constants.js.map